import React, { Component } from 'react';
import Tabletop from 'tabletop';

class Rounds extends Component {
	constructor() {
		super()
		this.state = {
			data: []
		}
	}

	componentDidMount() {
		Tabletop.init({
			key: '1pOk4gANazPxC_gfHyXoriLNOiQvb0dnvK52kh_L6SGA',
			callback: googleData => {
				this.setState({
					data: googleData
				})
			},
			simpleSheet: true
		})
	}

	render() {
		const { data } = this.state
		return (
			<div className="Overall">
				<div className="flex content-center">
					<div className="flex-grow self-center px-4">
						<h2>Round by Round</h2>
						<p><small>Ordered by dropped score</small></p>
					</div>
					<div className="flex-shrink self-center px-4">
						<ul>
							<li className="touring px-2">Touring</li>
							<li className="historic px-2">Historic</li>
							<li className="endurance px-2">Endurance</li>
						</ul>
					</div>
				</div>

				<div className="flex">
					<div className="col px-4">
						<div className="overallTable table-responsive rounds">
							<table cellPadding="0" cellSpacing="0" border="0" className="table">
								<thead>
									<tr>
										<th>Pos</th>
										<th className="grow">Driver</th>
										<th className="touring">R1 <span>Silverstone GP 1</span></th>
										<th className="touring">R2 <span>Silverstone Gp 2</span></th>
										<th className="historic">R3 <span>Silverstone Int</span></th>
										<th className="touring">R4 <span>Hockenheim 1</span></th>
										<th className="touring">R5 <span>Hockenheim 2</span></th>
										<th className="endurance">R6 <span>Spa</span></th>
										<th className="endurance">R7 <span>Monza</span></th>
										<th className="historic">R8 <span>Mugello</span></th>
										<th className="touring">R9 <span>Zandvoort 1</span></th>
										<th className="touring">R10 <span>Zandvoort 2</span></th>
										<th className="touring">R11 <span>Sochi 1</span></th>
										<th className="touring">R12 <span>Sochi 2</span></th>
										<th className="touring">R13 <span>Brands Indy 1</span></th>
										<th className="touring">R14 <span>Brands Indy 2</span></th>
										<th className="endurance">R15 <span>Nürburgring GP</span></th>
										<th className="endurance">R16 <span>Barcelona</span></th>
										<th className="historic">R17 <span>Portimao</span></th>
										<th className="endurance">R18 <span>Imola</span></th>
										<th className="historic">R19 <span>Istanbul 1</span></th>
										<th className="historic">R20 <span>Istanbul 2</span></th>
										<th className="endurance">R21 <span>Nordschleife</span></th>
										<th className="touring">R22 <span>Bahrain 1</span></th>
										<th className="touring">R23 <span>Bahrain 2</span></th>
										<th className="touring">R24 <span>Bahrain 3</span></th>
										<th className="historic">R25 <span>Brands GP 1</span></th>
										<th className="historic">R26 <span>Brands GP 2</span></th>
										<th className="touring">R27 <span>Yas Marina 1</span></th>
										<th className="touring">R28 <span>Yas Marina 2</span></th>
										<th className="touring">R29 <span>Yas Marina 3</span></th>
										<th className="endurance">R30 <span>Watkins Glen</span></th>
										<th className="overall">Overall</th>
										<th className="ds">DS</th>
									</tr>
								</thead>
								<tbody>
								{
									data.map(obj => {
										return (
											<tr className={obj.eligible} key={obj.driver}>
												<td>{obj.pos}</td>
												<td className="grow"><span className="number" style={{color:obj.colour}}>{obj.number}</span> {obj.driver}</td>
												<td>{obj.silvGp1}</td>
												<td>{obj.silvGp2}</td>
												<td>{obj.silvInt}</td>
												<td>{obj.hock1}</td>
												<td>{obj.hock2}</td>
												<td>{obj.spa}</td>
												<td>{obj.monza}</td>
												<td>{obj.mugello}</td>
												<td>{obj.zand1}</td>
												<td>{obj.zand2}</td>
												<td>{obj.sochi1}</td>
												<td>{obj.sochi2}</td>
												<td>{obj.brandsIndy1}</td>
												<td>{obj.brandsIndy2}</td>
												<td>{obj.nurbGp}</td>
												<td>{obj.barcelona}</td>
												<td>{obj.portimao}</td>
												<td>{obj.imola}</td>
												<td>{obj.istanbul1}</td>
												<td>{obj.istanbul2}</td>
												<td>{obj.nordschleife}</td>
												<td>{obj.bahrain1}</td>
												<td>{obj.bahrain2}</td>
												<td>{obj.bahrain3}</td>
												<td>{obj.brandsGp1}</td>
												<td>{obj.brandsGp2}</td>
												<td>{obj.yas1}</td>
												<td>{obj.yas2}</td>
												<td>{obj.yas3}</td>
												<td>{obj.watkinsGlen}</td>
												<td><span>{obj.overall}</span></td>
												<td><span>{obj.dropped}</span></td>
											</tr>
										)
									})
								}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Rounds;
